import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    docsUploadLoading: {
        id: '_.apply_flexi_loan.newDocUploads.docs_upload_loading',
        defaultMessage: "We're preparing your requirements..."
    },
    heading: {
        id: '_.apply_flexi_loan.newDocUploads.heading',
        defaultMessage: 'Apply for another loan'
    },
    topupHeading: {
        id: '_.apply_flexi_loan.newDocUploads.topupHeading',
        defaultMessage: 'Request more funds'
    },
    subheading: {
        id: '_.apply_flexi_loan.newDocUploads.subheading',
        defaultMessage: 'Thanks for applying for {amount}'
    },
    topUpSubheading: {
        id: '_.apply_flexi_loan.newDocUploads.topUpSubheading',
        defaultMessage: 'Thanks for applying for an additional {amount}'
    },
    headingInfo: {
        id: '_.apply_flexi_loan.newDocUploads.heading_info',
        defaultMessage:
            'We need some more information from you before we can make a decision.'
    },
    headingInfoCompleted: {
        id: '_.apply_flexi_loan.newDocUploads.heading_info_completed',
        defaultMessage:
            "We've got everything that we need from you for now. Click 'Submit Application' to continue"
    },
    saveApplicationSubheading: {
        id: '_.apply_flexi_loan.newDocUploads.save_application_subheading',
        defaultMessage:
            "Don't worry if you haven't got these to hand - we'll save your application progress so you can pick up where you left off."
    },

    submitCTA: {
        id: '_.apply_flexi_loan.newDocUploads.submit_cta',
        defaultMessage: 'Submit application'
    }
});
